import { createFileRoute } from "@tanstack/react-router";

import {
  SECTION_KEYS,
  SectionFormWrapper,
  AttributeRenderer,
  prefetchContractingCorporationProfile,
  useSaveRegistration,
  type RenderContentProps,
} from "../-shared";

export const Route = createFileRoute(
  "/_staff/settings/contracting-corporation-profile/_layout/registration/",
)({
  component: Registration,
  loader: prefetchContractingCorporationProfile,
});

function Registration() {
  return (
    <SectionFormWrapper
      sectionKey={SECTION_KEYS.REGISTRATION_INFORMATION}
      useSaveMutation={useSaveRegistration}
      renderContent={({ section }: RenderContentProps) => (
        <AttributeRenderer
          attributes={section.attributes}
          sectionKey={String(section.sectionKey)}
        />
      )}
    />
  );
}
